import {
  GL_BINOCULARS,
  GL_COLORS,
  GLEmptyList,
  GLTable,
  GLTableSkeleton,
} from "@group-link-one/grouplink-components";

import { CardsDesktop, CardsMobile } from "../Cards/cards";
// import { EventListCards } from "../Cards/EventListCards";
import { useTableContent } from "./useTableContent";

export function EventListTableContent() {
  const { events, handleScroll, isLoading, state, columns, isMobile } =
    useTableContent();

  return (
    <>
      {events && events?.length > 0 ? (
        <GLTable
          onScroll={handleScroll}
          columns={columns}
          isLoading={state.isFetchingMoreEvents}
          content={
            !isMobile ? (
              <CardsDesktop events={events} />
            ) : (
              <CardsMobile events={events} />
            )
          }
        />
      ) : isLoading ? (
        <GLTableSkeleton />
      ) : (
        <GLEmptyList
          title={state.emptyState.title}
          description={state.emptyState.description}
          icon={
            <GL_BINOCULARS size={30} fill={GL_COLORS.FONT_COLOR_DARK_GREY} />
          }
          hasBorder
        />
      )}
    </>
  );
}
